import React, { useEffect, useState } from 'react';
import { Card, Statistic, Row, Col, Typography, Tag, Divider, Spin, Space } from 'antd';
import { dashboardService, FreightIndexResponse } from '../../services/dashboardService';
import { ArrowUpOutlined, ArrowDownOutlined, CompassOutlined, RocketOutlined } from '@ant-design/icons';

const { Text } = Typography;

export const FreightIndexCard: React.FC = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<FreightIndexResponse['data'] | null>(null);

    useEffect(() => {
        const load = async () => {
            try {
                const res = await dashboardService.getFreightIndices();
                if (res.success) {
                    setData(res.data);
                }
            } catch (e) {
                console.error('Failed to load freight indices', e);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, []);

    const renderIndices = (indices: any[]) => (
        <Row gutter={[16, 16]}>
            {indices.map((item, index) => (
                <Col span={12} key={index}>
                    <Statistic
                        title={<Text type="secondary" style={{ fontSize: 12 }}>{item.name}</Text>}
                        value={item.value}
                        precision={2}
                        valueStyle={{ color: item.trend === 'up' ? '#cf1322' : '#3f8600', fontSize: 18 }}
                        prefix={item.trend === 'up' ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
                        suffix={<span style={{ fontSize: 11, color: '#999' }}>{item.unit}</span>}
                    />
                    <div style={{ fontSize: 10, color: '#999', marginTop: -4 }}>{item.desc}</div>
                </Col>
            ))}
        </Row>
    );

    return (
        <Card
            title="运价指数趋势"
            size="small"
            className="dashboard-card"
            bodyStyle={{ padding: 12, height: '100%' }}
            extra={data ? <Tag color="blue">{data.update_time}</Tag> : null}
        >
            {loading ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: 150 }}><Spin /></div> : (
                data && (
                    <Row gutter={[16, 0]} style={{ height: '100%' }}>
                        <Col span={12} style={{ borderRight: '1px solid #f0f0f0' }}>
                            <div style={{ marginBottom: 8 }}>
                                <Space align="center">
                                    <CompassOutlined style={{ color: '#1890ff' }} />
                                    <Text strong>海运指数 (SCFI)</Text>
                                </Space>
                            </div>
                            {renderIndices(data.ocean)}
                        </Col>
                        <Col span={12} style={{ paddingLeft: 16 }}>
                            <div style={{ marginBottom: 8 }}>
                                <Space align="center">
                                    <RocketOutlined style={{ color: '#722ed1' }} />
                                    <Text strong>空运指数 (TAC)</Text>
                                </Space>
                            </div>
                            {renderIndices(data.air)}
                        </Col>
                    </Row>
                )
            )}
        </Card>
    );
};
